import { useState } from "react";
import { toast } from "sonner";
import { Check, Pencil, X } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";
import { money } from "@/lib/format";

export default function JetBudgetEditor({ trip, onSaved }) {
  const api = useApi();
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const num = value === "" ? null : Number(value);
    if (num !== null && !(num > 0)) return toast.error("Enter a budget above 0");
    setSaving(true);
    try {
      const { data } = await api.patch(`/trips/${trip.id}/budget`, { budget: num });
      const over = data.options.filter((o) => o.over_budget).length;
      toast.success(num ? `Jet Card budget set to ${money(num)}${over ? `. ${over} option${over === 1 ? " is" : "s are"} over budget` : ""}` : "Jet Card budget cleared");
      setEditing(false);
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="col-span-2" data-testid="trip-jet-budget">
      <p className="text-[0.58rem] tracking-[0.22em] uppercase text-zinc-500">Jet Card budget</p>
      {editing ? (
        <div className="flex items-center gap-1.5 mt-1">
          <input type="number" min="1" step="0.01" autoFocus value={value} onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
            placeholder="e.g. 45000" className="w-40 h-9 px-2 bg-[#0d0f14] border border-white/15 text-white text-sm focus:outline-none focus:border-[#5B7FD1]"
            data-testid="jet-budget-input" />
          <button onClick={save} disabled={saving} className="p-2 text-[#5B7FD1] hover:text-white" aria-label="Save budget" data-testid="jet-budget-save-btn"><Check size={15} /></button>
          <button onClick={() => setEditing(false)} className="p-2 text-zinc-500 hover:text-white" aria-label="Cancel" data-testid="jet-budget-cancel-btn"><X size={15} /></button>
        </div>
      ) : (
        <button onClick={() => { setValue(trip.jet_card_budget ?? ""); setEditing(true); }} data-testid="jet-budget-edit-btn"
          className="group inline-flex items-center gap-2 mt-1 font-serif-display text-xl text-[#5B7FD1] hover:text-white transition-colors">
          {trip.jet_card_budget ? money(trip.jet_card_budget) : <span className="font-sans text-xs tracking-[0.15em] uppercase">Set budget</span>}
          <Pencil size={12} className="opacity-60 group-hover:opacity-100" />
        </button>
      )}
      <p className="text-[11px] text-zinc-500 mt-1">This is the client's price on every option. Options costing more are flagged.</p>
    </div>
  );
}
